export const rankingParticipantSummaryEn = {
  title: 'Competition overview',
  help: 'Counted totals across all participants in the competition.',
  totalViews: 'Counted views',
  totalPosts: 'Counted videos',
  totalParticipants: 'Participants in the ranking',
  countedVideos_one: '{{formattedCount}} counted video',
  countedVideos_zero: '{{formattedCount}} counted videos',
  countedVideos_other: '{{formattedCount}} counted videos',
  platformViews: 'Counted views by platform',
  platformHelp: 'The distribution of counted views across the four platforms.',
  publicationViews: 'Counted views by publication date',
  publicationHelp: 'Grouped by the clip’s publication date in {{timezone}}. These bars do not show daily view growth.',
  unavailable: 'Competition summary unavailable.',
  unavailableValue: 'Unavailable',
  platformUnavailable: 'Platform breakdown unavailable.',
  publicationUnavailable: 'Publication-date breakdown unavailable.',
  noCountedViews: 'No counted views yet.',
  noPublicationDates: 'No counted publication dates available.',
  platforms: { tiktok: 'TikTok', instagram: 'Instagram', youtube: 'YouTube', facebook: 'Facebook' },
};

export const rankingParticipantSummaryPt = {
  title: 'Resumo da competição',
  help: 'Totais contabilizados de todos os participantes da competição.',
  totalViews: 'Visualizações no ranking',
  totalPosts: 'Vídeos contabilizados',
  totalParticipants: 'Participantes no ranking',
  countedVideos_one: '{{formattedCount}} vídeo contabilizado',
  countedVideos_zero: '{{formattedCount}} vídeos contabilizados',
  countedVideos_other: '{{formattedCount}} vídeos contabilizados',
  platformViews: 'Visualizações no ranking por rede',
  platformHelp: 'Distribuição das visualizações contabilizadas entre as quatro redes.',
  publicationViews: 'Visualizações no ranking por data de publicação',
  publicationHelp: 'Agrupadas pela data de publicação do vídeo em {{timezone}}. As barras não representam o crescimento diário de visualizações.',
  unavailable: 'Resumo da competição indisponível.',
  unavailableValue: 'Indisponível',
  platformUnavailable: 'Distribuição por rede indisponível.',
  publicationUnavailable: 'Distribuição por data de publicação indisponível.',
  noCountedViews: 'Ainda não há visualizações contabilizadas.',
  noPublicationDates: 'Nenhuma data de publicação contabilizada disponível.',
  platforms: { tiktok: 'TikTok', instagram: 'Instagram', youtube: 'YouTube', facebook: 'Facebook' },
};
